import { Badge, Icon, SuitabilityBadge, Text, Tooltip, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Pressable, Box } from 'native-base';
import React, { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';

import { CustomerWalletPoints } from '../../../../../components/CustomerWalletPoints';
import { useCustomerActions } from '../../../../../store/customer/actions';
import { customerStatusState } from '../../../../../store/customer/atom';
import { useProductActions } from '../../../../../store/product/actions';
import { productStatusState } from '../../../../../store/product/atom';
import { CustomerItemSelectedProps } from '../models';

export const MobileCustomerItemSelected: React.FC<CustomerItemSelectedProps> = (props) => {
  const { updateCustomerStatus } = useCustomerActions();
  const { updateProductStatus } = useProductActions();

  const customerStatus = useRecoilValue(customerStatusState);
  const productStatus = useRecoilValue(productStatusState);

  const [isOpen, setIsOpen] = useState(false);

  const iconName = isOpen ? 'ChevronUp' : 'ChevronDown';

  const customerStatusIsOpened = customerStatus.status === 'opened';

  const handleEditCustomer = () => {
    const customerStatusData = {
      label: customerStatusIsOpened ? 'Cliente selecionado' : 'Trocar o cliente',
      status: customerStatusIsOpened ? 'completed' : 'opened',
    } as const;

    updateCustomerStatus(customerStatusData);
    updateProductStatus({
      label: 'Selecione o produto',
      status: customerStatusIsOpened ? 'opened' : 'locked',
    });
  };

  const buttonStatus = {
    text: customerStatusIsOpened ? 'Manter cliente' : 'Trocar cliente',
    iconName: customerStatusIsOpened ? 'ChevronRight' : 'Reverse',
  } as const;

  useEffect(() => {
    if (customerStatus.status === 'completed' && productStatus.status === 'completed') {
      setIsOpen(true);
    }
  }, [customerStatus.status, productStatus.status]);

  return (
    <Box pt={Spacing['inline.xxxs']}>
      <VStack px={Spacing['inline.xxxs']}>
        <Pressable onPress={() => setIsOpen(!isOpen)}>
          <HStack
            p={Spacing['inline.xxxs']}
            alignItems={'center'}
            justifyContent={'space-between'}
            bg={'neutral.white'}
            borderRadius={BoxRadius.sm}>
            <Text fontSize={Typography['fontsize.md']} variant="semibold" color={'neutral.black'}>
              Cliente selecionado
            </Text>
            <HStack space={Spacing['inline.nano']}>
              <Badge
                testId={'badge-customer-selected'}
                backgroundColor={'feedback.success.default'}
                textColor={'neutral.white'}>
                Concluído
              </Badge>
              <Icon name={iconName} size="xs" testId="icon-customer-selected" />
            </HStack>
          </HStack>
        </Pressable>
        {isOpen && (
          <VStack
            p={Spacing['inline.xxxs']}
            bg={'neutral.white'}
            mt={0.5}
            borderBottomRadius={BoxRadius.sm}
            space={Spacing['inline.xxxs']}>
            <HStack alignItems={'center'} space={Spacing['inline.nano']}>
              <Tooltip testId="qa" label={props.customerItem.suitabilityProfileName || ''}>
                <SuitabilityBadge
                  label={props.customerItem.suitabilityProfileName || ''}
                  hideText
                />
              </Tooltip>
              <Text variant={'semibold'} color={'neutral.black'} numberOfLines={1}>
                {props.customerItem.name}
              </Text>
            </HStack>
            <VStack space={Spacing['inline.nano']}>
              <HStack alignItems={'center'} justifyContent={'space-between'}>
                <Text color="neutral.dark">Saldo Disponível</Text>
                <Text color="neutral.black">
                  {Utils.Mask.Money(props.customerItem.availableBalance)}
                </Text>
              </HStack>
              <HStack alignItems={'center'} justifyContent={'space-between'}>
                <Text color="neutral.dark">Saldo estimado</Text>
                <Text color="neutral.black">{props.estimatedValue}</Text>
              </HStack>
              <HStack alignItems={'center'} justifyContent={'space-between'}>
                <Text color="neutral.dark">Pts na carteira</Text>
                <CustomerWalletPoints accountNumber={props.customerItem.accountNumber} />
              </HStack>
            </VStack>
            <Pressable testID={'button-change-customer'} w={'100%'} onPress={handleEditCustomer}>
              <HStack alignItems={'center'} justifyContent={'space-between'} w={'full'}>
                <Text
                  color={'brand.tertiary.principal'}
                  variant="semibold"
                  fontSize={Typography['fontsize.md']}
                  textTransform="uppercase">
                  {buttonStatus.text}
                </Text>
                <Icon
                  testId={'icon-edit'}
                  name={buttonStatus.iconName}
                  size="xxs"
                  color={Color['brand.tertiary.principal']}
                />
              </HStack>
            </Pressable>
          </VStack>
        )}
      </VStack>
    </Box>
  );
};
